<div class="dialog_main success_main">
  <button type="button" class="dialog_close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="dialog_body">
    <figure><img [src]="assetsConst.success_icon" alt="Icon" /></figure>
    <h2>{{ 'Woohooh' | translate }}</h2>
    @if (data.becomeMember) {
      <p>
        {{ 'OurTeamwillgettoyou' | translate }}<br />
        {{ 'within24hour' | translate }}
      </p>
    } @else {
      <p>
        {{ 'Yourpaymentissuccessfully' | translate }} <br />
        {{ 'completed' | translate }}.
      </p>
    }
    <button type="button" class="btn btn_primary" (click)="continue()">
      {{ 'Continue' | translate }}
    </button>
  </div>
</div>
